var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"draggable",rawName:"v-draggable",value:(_vm.dragConfig),expression:"dragConfig"}],staticClass:"oms-drag-wrapper",style:({ left: _vm.position.x + 'px', top: _vm.position.y + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }